import { c as _c } from "react/compiler-runtime";
import { IcoEyeCrossed16 } from '@onefootprint/icons';
import { Form, Select, Toggle, Tooltip } from '@onefootprint/ui';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import Section from '@/playbook-builder/components/section';
import type { FormIdentityData } from '../../collect-data-node/components/person/person.types';
type ConfirmationSectionProps = {
  canEdit: boolean;
  isFirmEmployee: boolean;
};
export const ConfirmationSection = t0 => {
  const $ = _c(47);
  const {
    canEdit,
    isFirmEmployee
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "collectData.person.confirmation"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("playbook-builder", t1);
  const {
    setValue
  } = useFormContext();
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      name: "confirmationMode"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const mode = useWatch(t2);
  const isSkip = mode === "skip";
  let t3;
  if ($[2] !== setValue) {
    t3 = next => setValue("confirmationMode", next, {
      shouldDirty: true
    });
    $[2] = setValue;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const setMode = t3;
  let t4;
  if ($[4] !== t) {
    t4 = t(_temp);
    $[4] = t;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = !canEdit;
  let t6;
  if ($[6] !== t) {
    t6 = t(_temp2);
    $[6] = t;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const t7 = isSkip ? "skip" : "confirm";
  let t8;
  if ($[8] !== mode || $[9] !== setMode) {
    t8 = value => setMode(value === "skip" ? "skip" : mode === "always_confirm" ? "always_confirm" : "confirm");
    $[8] = mode;
    $[9] = setMode;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t) {
    t9 = t(_temp3);
    $[11] = t;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t9) {
    t10 = {
      value: "confirm",
      label: t9
    };
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== t) {
    t11 = t(_temp4);
    $[15] = t;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== t11) {
    t12 = {
      value: "skip",
      label: t11
    };
    $[17] = t11;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== t10 || $[20] !== t12) {
    t13 = [t10, t12];
    $[19] = t10;
    $[20] = t12;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== t13 || $[23] !== t5 || $[24] !== t6 || $[25] !== t7 || $[26] !== t8) {
    t14 = <Select disabled={t5} label={t6} value={t7} onChange={t8} options={t13} size="compact" />;
    $[22] = t13;
    $[23] = t5;
    $[24] = t6;
    $[25] = t7;
    $[26] = t8;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== isSkip || $[29] !== t) {
    t15 = isSkip ? t(_temp5) : t(_temp6);
    $[28] = isSkip;
    $[29] = t;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== t15) {
    t16 = <p className="text-caption-2 text-tertiary">{t15}</p>;
    $[31] = t15;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== t14 || $[34] !== t16) {
    t17 = <div className="flex flex-col gap-2">{t14}{t16}</div>;
    $[33] = t14;
    $[34] = t16;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] !== canEdit || $[37] !== isFirmEmployee || $[38] !== isSkip || $[39] !== mode || $[40] !== setMode || $[41] !== t) {
    t18 = isFirmEmployee && !isSkip && <><div className="flex flex-col gap-2"><div className="flex items-center justify-between gap-2"><Toggle disabled={!canEdit} label={t(_temp7)} checked={mode === "always_confirm"} onChange={checked => setMode(checked ? "always_confirm" : "confirm")} size="compact" /><Tooltip content={t(_temp8)} side="left"><div className="flex-shrink-0 text-tertiary"><IcoEyeCrossed16 /></div></Tooltip></div><p className="text-caption-2 text-tertiary">{t(_temp9)}</p></div><div className="flex flex-col gap-2"><div className="flex items-center justify-between gap-2"><Form.Toggle disabled={!canEdit} name="useCompactConfirm" label={t(_temp10)} size="compact" /><Tooltip content={t(_temp11)} side="left"><div className="flex-shrink-0 text-tertiary"><IcoEyeCrossed16 /></div></Tooltip></div><p className="text-caption-2 text-tertiary">{t(_temp12)}</p></div></>;
    $[36] = canEdit;
    $[37] = isFirmEmployee;
    $[38] = isSkip;
    $[39] = mode;
    $[40] = setMode;
    $[41] = t;
    $[42] = t18;
  } else {
    t18 = $[42];
  }
  let t19;
  if ($[43] !== t17 || $[44] !== t18 || $[45] !== t4) {
    t19 = <Section title={t4}>{t17}{t18}</Section>;
    $[43] = t17;
    $[44] = t18;
    $[45] = t4;
    $[46] = t19;
  } else {
    t19 = $[46];
  }
  return t19;
};
function _temp($) {
  return $.title;
}
function _temp2($_0) {
  return $_0.mode.label;
}
function _temp3($_1) {
  return $_1.mode.confirm;
}
function _temp4($_2) {
  return $_2.mode.skip;
}
function _temp5($_3) {
  return $_3.mode.hints.skip;
}
function _temp6($_4) {
  return $_4.mode.hints.confirm;
}
function _temp7($_5) {
  return $_5.alwaysConfirm.label;
}
function _temp8($_6) {
  return $_6.employeeOnly;
}
function _temp9($_7) {
  return $_7.alwaysConfirm.hint;
}
function _temp10($_8) {
  return $_8.compact.label;
}
function _temp11($_9) {
  return $_9.employeeOnly;
}
function _temp12($_10) {
  return $_10.compact.hint;
}